// Phone input sanitiser.
//
// A direct port of the storefront checkout's "phone number fix" effect
// (ttm-react-app/.../routes/checkout/checkout.page.jsx), which is the known-good
// behaviour. Digits and a leading "+" survive; everything else goes.
//
// Deliberately NOT a formatter. No spaces, dashes or brackets are inserted:
// the value is submitted to Recurly as the shipping phone and read back by
// Sendinblue as an SMS number, and both want it bare. Grouping it for looks
// would mean stripping the grouping again before submit.

// Only the first character may be a "+", so a country code can be typed but a
// stray one mid-number can't survive a paste.
export function maskPhone(raw) {
  const digits = String(raw || '').replace(/[^+0-9]+/g, '');
  return digits.charAt(0) + digits.slice(1).replace(/\+/g, '');
}

// NANP-only (2026-09-19) — this field ships to the US and Canada, which share
// +1, so there is nothing left to infer from digit count. The design used to
// guess +61/+44 for a 9- or 11-digit number; that guessing never lived in
// shared-ui (it was a storefront bug, fixed there), so there's nothing to
// remove here — this is purely the validation/E.164 half of that same fix,
// for whoever hashes this field for an ad platform. Ignores everything but
// digits, drops a leading country "1", and accepts only a real 10-digit NANP
// number (area code and exchange code can't start with 0 or 1). Returns ''
// rather than throwing — this field stays optional, so an unparsable value is
// a validation error on blur, not a hard failure.
export function normalisePhone(raw) {
  let digits = String(raw || '').replace(/\D+/g, '');
  if (digits.length > 10 && digits.charAt(0) === '1') digits = digits.slice(1);
  return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits) ? `+1${digits}` : '';
}
